module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ct para-style-override-3",
    attrs: {
      "id": "toc_marker-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/There_Was_a_Crooked_Man2#Contents-A"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("A fierce wind blew off the lake, rattling the catwalk beneath my feet. I hovered fifty feet in the air on a sketchy billboard marked for demolition by the city of Chicago. Shimmying up this godforsaken structure hadn’t been one of my smarter moves. But then, being a hotshot detective doesn’t mean you have good sense.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I was armed with spy-eyes, a long-focus lens camera, and a Snickers bar. From my vantage point, I had a bird’s-eye view of trendy shops and old-time bars in this South Chicago neighborhood. Bridgeport has a funky, friendly vibe and a history rife with gangsters and shady politicians. There’s a strong sense of community here and you know your neighbor has your back. If he thinks you want to kill yourself, he’s right there cheering you on.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("My gaze swept the street below and froze on Johnnie’s Grill and Sports Bar. The proprietor, Johnnie Rizzo, is a study in brute testosterone and charm. He’s got ravishing brown eyes that suck women in. I was close enough to pitch a rock through his window. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I fell crazy in love with Johnnie the summer I worked at his restaurant. It happened in the walk-in cooler, pressed up against the wall, wedged between a slab of beef and five-gallon buckets of condiments. Johnnie had slow hands and fast fingers. We were married before my feet hit the ground. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("A few months into marital bliss I planned a surprise for Johnnie. I sashayed into the cooler all dolled up in high heels, a faux leopard fur coat, and my birthday suit. And there was Johnnie, thrust between the hanging beef and the five-gallon condiments. And a ditzy blond waitress. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Same wall. Different ketchup. Different cow.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("That was the day my feet hit the ground and stayed there. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("It wasn’t long before I discovered I’d married a serial cheater.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("My marriage was a bust but it rocket-started my career. Chasing Johnnie Rizzo’s cheating ass gave me mad skills. I earned my PI license and launched the Pants On Fire Detective Agency. I don’t investigate for law firms or insurance companies and I won’t find your lost Uncle Hal. But if you’re in Chicagoland and you suspect your partner is stepping out, give me a call. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("My name is Cat DeLuca, PI, and I catch cheaters.")]), _vm._v(" "), _c('p', {
    staticClass: "section"
  }, [_vm._v("***")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("I turned my back on Johnnie’s Grill and Sports Bar and set my sights on the brownstone apartment across the street. The wind off the lake clawed at me and the old, wooden bones beneath me shuddered. I said a couple Hail Marys, aimed my spy-eyes and counted the panes of glass. Four floors up, four windows over. Apartment 4B. That’s where the “other woman” receives her mail. And an eighteen hundred-smacker Laura Ashley loveseat. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("My client, Dorrie Gillet, discovered the charge on her husband’s platinum Visa. It was a stunning truffle microfiber loveseat viewed through my binoculars. She’d hired me to track down the loveseat, but I suspect she was more interested in the buns that warmed it. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Dorrie’s husband, Sheldon, shows all the signs of a middle-aged cheater. He traded his Prius for a Camaro. He buys gifts she never sees and his little blue pills disappear like candy. He’s definitely not rising to the occasion at home.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Last month Sheldon blew a bundle of their savings on a hair transplant. Dorrie showed me before and after pictures. They were amazing. He might have George Clooney hair now. But his face still screams Elmer Fudd.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“I suspect Shelly is cheating on me,” she said bitterly.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Seriously?")]), _vm._v(" I glanced at the photo of Elmer again. “Have you talked to him about it?”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“He laughed at me. He said I was imagining things.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("That’s what they all say.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Her lips pursed in an angry line. “Sheldon is a church deacon, for God’s sake. I told our pastor he’s catting around. I said, ‘Shelly’s going to hell.’” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“What did your pastor say?”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“He said Sheldon’s experiencing a mid-life crisis. That God wants me to forgive him.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I didn’t trust myself to respond. I whipped out my Dr. Pepper Lip Smacker and smeared my mouth. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“When hell freezes over,” Dorrie said. “That’s what I said to the pastor. I told him God wants Sheldon to keep his pants zipped.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I tucked the Lip Smacker in my jeans’ pocket. Her eyes had a hard, terrifying glint. I almost expected her head to start spinning. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“I’ve been a good wife to that man.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“What do you want from me?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“I want you to find out where that loveseat was delivered.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“And then torch it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I smiled. “Sorry. I don’t—”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“But you know someone who does.” One crazy eye winked. “And I want hard evidence that I can slap in Sheldon’s face. One photograph of the lying bastard to prove I’m not bat-shit crazy.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("That could take more than a photo. Or maybe not.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I considered her cray-cray eyes thoughtfully. Perhaps she wasn’t so bat-shit after all. Dorrie Gillet’s life, as she knew it, was unraveling. She felt betrayed. She was pissed off. But mostly she was scared shitless. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In this business, I meet people on their very worst days. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I touched her hand. “I’ll find out the truth about your husband. And I’ll get your photo. My 8 by 10 glossies will clear or convict him.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("She found a tissue in her bag and blew her nose. It sounded a lot like a foghorn. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“I am a just Christian woman.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“And I will choke the thankless fornicator in his sleep.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Uhm…”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Dorrie slapped a wad of cold hard cash on my desk. “We never had this conversation. I was never here.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("And just like that, "), _c('span', {
    staticClass: "Italic"
  }, [_vm._v("Poof!")]), _vm._v(" She wasn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "section"
  }, [_vm._v("***")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("I had been stalking the thankless fornicator for days and he’d been on his best behavior. But that ship was about to sail. Today I followed Sheldon after work to his lover’s brownstone. Her name is Michelle and she’s a sous chef at a French bistro in Hyde Park. She likes retro furniture and peppermint patties. She props an insane number of stuffed toys on her bed. She wears baby-doll lingerie. There was a home pregnancy test in her waste basket. Negative. And the loveseat is amazing.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I know this because I broke into Michelle’s apartment when she was at work. I got her address from the delivery guys at Walter E. Smithe. They remembered the loveseat, all right. Maybe because they hoisted it four miserable flights up a narrow, sweat-box stairway without so much as a tip or a thank you. I gladly gave them both. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I was in Michelle’s apartment when I decided to climb the billboard for my photo-op. The structure is mildly treacherous but it’s a straight camera shot to Michelle’s bedroom window. I waited in my car for Sheldon to enter his lover’s apartment. Then I crossed my fingers, made my peace with God, and jumped the yellow police tape. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I aimed my long focus lens camera at Apartment 4B across the street. Michelle’s menagerie of stuffed animals had been moved to three shelves. Elmer Fudd sprawled on the bed alone, head propped on a pillow, wearing a pair of stars and stripes bikini briefs. It appeared another little blue pill had been activated for takeoff. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Sheldon had the soft, undeveloped body of a guy who was never into sports and spends too many weekends on the couch. He may have been captain of the debate team in school but he would’ve been the last kid picked for sports. He didn’t have a lot of body hair, just a few honey-gold tufts around his man-breasts. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Come on,” I whispered. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("As if on command, Michelle emerged from the bathroom in a soft pink baby doll and white fishnet stockings. She had long black hair and skin like caramel. She may not have Sheldon’s generous breasts but she’s an attractive woman in her own right with firm, wide hips and a round, shapely caboose. She danced for him slowly, gliding around the bed with an easy, sensual motion. Her fingers explored her skin and she danced as if she was making love to her body. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I focused the camera lens. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Say cheese.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Click")]), _vm._v(". ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Her hips sashayed seductively and her arms were fluid as melted butter. She stripped for Elmer, removing her spaghetti straps slowly, one by one, until all she wore was a delicate gold anklet with diamond and ruby hearts. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Click.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Elmer Fudd’s eyes bulged. He appeared as if his face would explode.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Click. Click.")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("His eyebrows darted up and down and beads of sweat dribbled from his George Clooney hair. He watched her dance until he couldn’t contain himself a moment longer. Then he pulled her on the bed and kissed her hard before pushing her onto her knees. Michelle’s long black hair draped the stars and stripes, and the rocket’s red glare. And then Chef Michelle served up one of her French specialties. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I smiled. “Say Brie.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Click. Click. Click. ")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("A hefty gust of wind blew off the lake and the billboard’s wooden frame shuddered beneath me. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“It’s a wrap,” I said. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I took a bite of my Snickers and tucked the camera and binoculars into my shoulder bag. A shrill voice squawked from the street below. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Jumper! We’ve got a jumper!” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Jumper? My eyes swept the surrounding rooftops. Nada.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Jump! Jump!” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I looked down at the street where a small crowd was gathering. My heart sank. They were yelling at me. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("OMG!")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Jump! Jump!” An obnoxious guy chanted. A small chorus of doom joined in.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“I’m a city inspector!” I shouted but no one heard. They were having too much fun yelling at me. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Hold on, Dearie!” an old woman called. The cops are on their way! ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Crap!")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I began retracing my steps to the ladder, carefully negotiating the catwalk. A crowd of looky-lous poured out of Johnnie’s Sports Bar. They heard there was a jumper and they were pumped for a bloodbath. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I moved quickly, making my way to the ladder. An all-too-familiar voice called to me. My feet froze and my stomach lurched.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Kitten, stop!” Johnnie Rizzo bellowed. “I know you love me! Don’t jump! You can get over us!”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("“Holy crap!”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Ha!” I blubbered. I was stunned by the enormity of that man’s ego.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Johnnie wailed. “I’m not worth it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Captain Obvious has arrived, ladies and gentlemen!” I shot back. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Come down, Kitten! You don’t want to die!”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“I’m not jumping, fool!” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I scanned the crowd. Phones were held high in the air, videotaping. I groaned. My foiled suicide attempt and my Johnnie Rizzo heartbreak would certainly hit YouTube, if not the evening news. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“All right,” my ex cried, “I’m coming up for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Johnnie Rizzo is terrified of heights. His offer was enormously brave. And, I reluctantly admitted, rather sweet. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Go, Johnnie, go!” The bar crowd chanted. They were louder than the "), _c('span', {
    staticClass: "Italic"
  }, [_vm._v("Jump")]), _vm._v(" mob. Johnnie sucks people in. They love him. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“No, Johnnie, no!” I yelled, scampering for the ladder. “I’m coming down!”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Johnnie’s two hundred pounds might easily bring this billboard to its knees. I reached the ladder and began descending the steps.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The ladder brought me most of the way down. The final twenty feet I slid down a pole. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The nice people cheered. The"), _c('span', {
    staticClass: "Italic"
  }, [_vm._v(" Jump! ")]), _vm._v("crowd booed. And the "), _c('span', {
    staticClass: "Italic"
  }, [_vm._v("Go Johnnie Go")]), _vm._v(" bunch dissolved into the restaurant to freshen their drinks. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Sirens screamed. The cops were on their way. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Before my feet hit the ground, Johnnie caught me in his arms. He was trembling and his eyes were wet. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Thank God,” he breathed. His big brown eyes searched my face and he locked onto my eyes with his. I shuddered. He was sucking me in. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Damn those eyes")]), _vm._v(". I took a breath and pushed him away. “I wasn’t going to jump.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Of course you weren’t.” He didn’t believe me for a moment. “Okay, Kitten. You got what you wanted. You have my attention.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“I wasn’t trying to—"), _c('span', {
    staticClass: "Italic"
  }, [_vm._v("arrrgh!”")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I looked down the street. Flashing lights barreled down on us. Sirens screamed. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Gotta run.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“For God’s sake, Cat, get some help. See a shrink or something. If money’s a problem, business has been good. I’ve got what you need.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“You’re such an egotistical jackass.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I hightailed it toward my car as the first patrol cars screeched to the curb. My crazy Cousin Frankie jumped out first, hand on holster, always ready to shoot someone. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Hi, Frankie!” I waved. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Cat!” His head jerked side to side. “Did you see the jumper? Where did she go?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I pointed down the street. “She ran into Johnnie’s.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Frankie roared into his radio and a mass of blue swarmed Johnnie’s Sports Bar and Grill. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I looked over my shoulder at Johnnie. He shook his head and dragged a hand through his hair. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“Not cool, Kitten.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("But his big, woman-sucking eyes were smiling. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }), _vm._v(" "), _c('p', {
    staticClass: "body"
  }), _vm._v(" "), _c('p', {
    staticClass: "body"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82a816ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/There_Was_a_Crooked_Man-5.vue
// module id = 72
// module chunks = 0